import React, { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Gift, Loader2 } from "lucide-react";
import { adminAuthHeader } from "@/hooks/useAdminAuth";
import { extractApiError } from "@/utils/apiError";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

/**
 * Admin button to manually grant a user FREE access ONLY to Lessons 2, 3, 4
 * (the €50 bundle). Does NOT grant L5-9 / full course.
 */
export default function GrantBundle234Button({ userId, userName, alreadyGranted, onGranted }) {
  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    if (loading || alreadyGranted) return;
    const ok = window.confirm(
      `Sblocco GRATUITO Lezioni 2+3+4 per ${userName || "questo utente"}?\n\n` +
      "Verranno attivate SOLO le lezioni 2, 3 e 4 (bundle €50). " +
      "Le lezioni 5-9 e il corso completo NON saranno inclusi.\n\nProcedere?"
    );
    if (!ok) return;
    setLoading(true);
    try {
      await axios.post(
        `${API}/admin/users/${userId}/grant-bundle-234`,
        {},
        { headers: adminAuthHeader() },
      );
      toast.success("Lezioni 2+3+4 sbloccate gratuitamente");
      onGranted?.(userId);
    } catch (err) {
      toast.error(extractApiError(err, "Errore nello sblocco"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      disabled={loading || alreadyGranted}
      data-testid={`grant-bundle234-btn-${userId}`}
      className="inline-flex items-center gap-1.5 text-xs font-semibold px-3 py-1.5 rounded-md border transition disabled:opacity-50 disabled:cursor-not-allowed"
      style={{
        background: alreadyGranted ? "#ecfdf5" : "#eff6ff",
        borderColor: alreadyGranted ? "#86efac" : "#93c5fd",
        color: alreadyGranted ? "#065f46" : "#1e40af",
      }}
      title={alreadyGranted
        ? "Questo utente ha già accesso a L2+L3+L4"
        : "Sblocca solo lezioni 2, 3 e 4 gratis (bundle €50)"}
    >
      {loading
        ? <><Loader2 size={12} className="animate-spin" /> Sblocco…</>
        : <><Gift size={12} /> {alreadyGranted ? "L2+L3+L4 attive" : "🎁 Sblocca L2+L3+L4 gratis"}</>}
    </button>
  );
}
